import showdown from 'showdown';
import { ChildParams, MethodAttributes, translation } from '@/templates/References';
import { CreateElement, VNode } from 'vue';

export default abstract class Signature {
  public static LANG: string;
  public static converter: any = new showdown.Converter({ literalMidWordUnderscores: true });

  public static convertToHtml(item: string): string {
    return this.converter.makeHtml(this.convChar(item));
  }

  public static convChar(str: string): string {
    const c: { [char: string]: string } = {
      '<': '&lt;',
      '>': '&gt;',
      '&': '&amp;',
      '"': '&quot;',
      "'": '&#039;',
      '#': '&#035;',
    };
    return str?.replace(/[<&>'"#]/g, function (s: string) {
      return c[s];
    });
  }

  /**
   * Превращает массив в рендер функцию, которая возвращает строку вида: VideoSettings | boolean
   *
   * @param returnTypes - массив содержащий параметры метода заданные в method.returns
   * @return function - возвращает рендер функцию, которая создает часть сигнатуры
   */
  public static returnsType(
    returnTypes: Array<string | translation | ChildParams>
  ): (h: CreateElement) => VNode {
    if (!returnTypes || !returnTypes.length) return (h) => h();

    return (h) =>
      h(
        'span',
        returnTypes.map((item, idx: number) => {
          return h('span', { class: 'token md-parse type' }, [
            h('span', {
              domProps: { innerHTML: `${this.convertToHtml(<string>item)}` },
            }),
            !(idx === returnTypes.length - 1)
              ? h('span', { class: 'token punctuation' }, ' | ')
              : '',
          ]);
        })
      );
  }

  public static getAttributes(attributes: MethodAttributes): (h: CreateElement) => VNode {
    if (!attributes || !Object.keys(attributes)) return (h) => h();

    return (h) =>
      h(
        'span',
        Object.keys(attributes).map((key) => {
          return h('span', { class: 'token md-parse type' }, [
            h('span', key === 'readonly' && attributes[key] ? 'get; ' : ''),
            h('span', key === 'readwrite' && attributes[key] ? 'get; set; ' : ''),
          ]);
        })
      );
  }
}
